module.exports = __webpack_public_path__ + "static/img/Ordering_statistics.eb6a930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/Ordering_statistics.png
// module id = TJwg
// module chunks = 1